import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutBottom"><Path d="M3 17V3H21V17H3Z" fill="currentColor"/><Path d="M3 21V19.5H21V21H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutBottom;
